import { ClarionSpinner } from '@clarion/ClarionSpinner';
import NonIdealPage from '../util/NonIdealPage';

export default function EmbedLoadingScreen() {
  return <NonIdealPage title="Loading your content…" action={<ClarionSpinner size={30} />} />;
}
